import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function LegalEntityCreatePage() {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        companyName: "",
        registrationNumber: "",
        taxId: "",
        contactPerson: "",
        position: "",
        phone: "",
        country: "",
        city: "",
        postalCode: "",
        address: ""
    });

    const [error, setError] = useState("");

    const handleChange = e => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await api.post("/LegalEntity/create", form);
            navigate("/admin/legal");
        } catch (err) {
            setError("Create failed");
        }
    };

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">Create Legal Entity</h2>

            <form onSubmit={handleSubmit} className="space-y-3">

                <input name="companyName" onChange={handleChange} placeholder="Company Name" required className="input" />
                <input name="registrationNumber" onChange={handleChange} placeholder="Registration Number" required className="input" />
                <input name="taxId" onChange={handleChange} placeholder="Tax ID" required className="input" />
                <input name="contactPerson" onChange={handleChange} placeholder="Contact Person" required className="input" />
                <input name="position" onChange={handleChange} placeholder="Position" className="input" />
                <input name="phone" onChange={handleChange} placeholder="Phone" className="input" />

                <input name="country" onChange={handleChange} placeholder="Country" className="input" />
                <input name="city" onChange={handleChange} placeholder="City" className="input" />
                <input name="postalCode" onChange={handleChange} placeholder="Postal Code" className="input" />
                <input name="address" onChange={handleChange} placeholder="Address" className="input" />

                <button className="bg-indigo-600 text-white px-4 py-2 rounded">
                    Create
                </button>

                {error && <p className="text-red-600">{error}</p>}
            </form>
        </div>
    );
}